<template>
  <div
    @click="tryClose"
    data-notify="container"
    class="alert open row"
    :class="[
      { 'alert-with-icon': icon },
      verticalAlign,
      horizontalAlign,
      alertType
    ]"
    role="alert"
    :style="customPosition"
    data-notify-position="top-center">
    <div class="col-sm-10 align-content-center">
      <span v-if="type === 'basic'" data-notify="icon" :class="['alert-icon', 'nc-icon nc-bell-55']"></span>
      <span v-if="type.includes('required')" data-notify="icon" :class="['alert-icon', 'nc-icon nc-time-alarm']"></span>
      <span data-notify="message" style="margin-left: 50px">
      <span v-if="title" class="title"
      ><b>{{ title }}<br /></b
      ></span>
      <span v-if="message" v-html="message"></span>
      <content-render
        v-if="!message && component"
        :component="component"
      ></content-render>
    </span>
    </div>
    <div class="col-sm-2 align-content-center text-center">
      <button
        v-if="type === 'basic'"
        type="button"
        aria-hidden="true"
        class="notificationButton"
        data-notify="dismiss"
        @click="goToWriteNotes">
        Write Notes
      </button>
      <button
        v-if="type.includes('required')"
        type="button"
        aria-hidden="true"
        class="notificationButton"
        data-notify="dismiss"
        @click="goToLog">
        Log
      </button>
      <button
        v-if="showClose"
        type="button"
        aria-hidden="true"
        class="close col-xs-1"
        data-notify="dismiss"
        @click="close">
        <el-icon name="close" class="notificationClose"></el-icon>
      </button>
    </div>
  </div>
</template>
<script>
import { Icon } from 'element-ui';
export default {
  name: 'notification',
  components: {
    [Icon.name]: Icon,
    contentRender: {
      props: ['component'],
      render(h) {
        // register component locally if it's not registered
        let componentsObj = this.$options.components;
        if(!componentsObj[this.component.name]) {
          componentsObj[this.component.name] = this.component;
        }
        return h(this.component)
      }
    }
  },
  props: {
    message: String,
    title: String,
    icon: String,
    verticalAlign: {
      type: String,
      default: 'top',
      validator: value => {
        let acceptedValues = ['top', 'bottom'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    horizontalAlign: {
      type: String,
      default: 'center',
      validator: value => {
        let acceptedValues = ['left', 'center', 'right'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    type: {
      type: String,
      default: 'basic',
      validator: value => {
        let acceptedValues = [
          'info',
          'primary',
          'danger',
          'warning',
          'success',
          'basic',
          'requiredBlue',
          'requiredOrange',
        ];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    timeout: {
      type: Number,
      default: 10000,
      validator: value => {
        return value >= 0;
      }
    },
    timestamp: {
      type: Date,
      default: () => new Date()
    },
    component: {
      type: [Object, Function]
    },
    showClose: {
      type: Boolean,
      default: true
    },
    closeOnClick: {
      type: Boolean,
      default: true
    },
    clickHandler: Function
  },
  data() {
    return {
      elmHeight: 0
    };
  },
  computed: {
    hasIcon() {
      return this.icon && this.icon.length > 0;
    },
    alertType() {
      return `alert-${this.type}`;
    },
    customPosition() {
      let initialMargin = 80;
      let alertHeight = this.elmHeight + 10;
      let sameAlertsCount = this.$notifications.state.filter(alert => {
        return (
          alert.horizontalAlign === this.horizontalAlign &&
          alert.verticalAlign === this.verticalAlign &&
          alert.timestamp <= this.timestamp
        );
      }).length;
      if (this.$notifications.settings.overlap) {
        sameAlertsCount = 1;
      }
      let pixels = (sameAlertsCount - 1) * alertHeight + initialMargin;
      let styles = {};
      if (this.verticalAlign === 'top') {
        styles.top = `${pixels}px`;
      } else {
        styles.bottom = `${pixels}px`;
      }
      return styles;
    }
  },
  methods: {
    close() {
      this.$emit('close', this.timestamp);
    },
    tryClose(evt) {
      if (this.clickHandler) {
        this.clickHandler(evt, this);
      }
      if (this.closeOnClick) {
        this.close();
      }
    },
    goToWriteNotes(){
      alert('Went to Write Notes Page')
    },
    goToLog(){
      alert('Went to Log Page')
    },
  },
  mounted() {
    this.elmHeight = this.$el.clientHeight;
    if (this.timeout) {
      setTimeout(this.close, this.timeout);
    }
  }
};
</script>
<style lang="scss">
.notifications .alert {
  position: fixed;
  z-index: 1;

  &[data-notify='container'] {
    width: 400px;
  }
  &.center {
    margin: 0 auto;
  }
  &.left {
    left: 20px;
  }
  &.right {
    right: 20px;
  }
  &.alert-basic {
    background-color: #cb3731;
    color: white;
    border-color: #cb3731;
    width: 100%;
    border-radius: 3em;
    display: flex;
    height: 61px;
  }
  &.alert-requiredBlue {
    background-color: #187e95;
    color: white;
    border-color: #187e95;
    width: 100%;
    border-radius: 3em;
    display: flex;
    height: 61px;
  }
  &.alert-requiredOrange {
    background-color: #f05a29;
    color: white;
    border-color: #f05a29;
    width: 100%;
    border-radius: 3em;
    display: flex;
    height: 61px;
  }
}
.notificationButton{
  justify-self: right;
  padding: 3px 30px;
  background-color: transparent;
  border-radius: 10px;
  border: 1px white solid;
  color: white;
  font-weight: lighter;
  width: 80%;
}
.notificationClose{
  font-size: 16px;
}
.title{
  font-size: 20px;
}
.align-content-center{
  align-content: center;
}
.text-center{
  text-align: center;
  justify-content: center;
}
</style>
